import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getVersions = async (params) => {
	const { data } = await axios.get(`${API}/admin/versions`, {
		params,
	});
	return data;
};

export const getVersion = async (params) => {
	const { data } = await axios.get(`${API}/admin/versions/detail`, {
		params,
	});
	return data;
};

export const saveVersion = async (params) => {
	const { data } = await axios.post(`${API}/admin/versions/save`, params);
	return data;
};

export const deleteVersion = async (params) => {
	const { data } = await axios.post(`${API}/admin/versions/delete`, params);
	return data;
};
